export enum LogEvent {
  GEOCODE_USED = 'geocode_used',
  PLACES_AUTO_COMPLETE_USED = 'places_auto_complete_used',
}

export const usedForFeature = {
  HeaderFilterLocationDropdown: 'header_filter_location_dropdown',
  SEFriendlyHeaderFilterLocationDropdown:
    'se_friendly_header_filter_location_dropdown',
  PatientFormUsingLocationToGetTimezone:
    'patient_form_using_location_to_get_timezone',
  SearchPageAutoSelectCurrentLocationOrFromQuery:
    'search_page_auto_select_current_location_or_from_query',
  SEFriendlyHubPageAutoSelectCurrentLocation:
    'se_friendly_hub_page_auto_select_current_location',
  NavbarLocationFromSalesForce: 'navbar_location_from_salesforce',
  ResetSupportBooking: 'reset_support_booking',
  SupportDashboardAccountNotFoundSalesForceLocationRedirection:
    'support_dashboard_account_not_found_salesforce_location_redirection',
  PreSearchQuestionnaire: 'pre_search_questionnaire',
  SimpleInsuranceVerification: 'simple_insurance_verification',
}
